import * as React from "react";
import { Component } from "react";
import {
  Button,
  Col,
  ControlLabel,
  DropdownButton,
  Form,
  FormControl,
  FormGroup,
  Glyphicon,
  MenuItem,
  Modal,
  Nav,
  Navbar,
  NavItem,
  Table,
} from "react-bootstrap";
import { NavLink, Redirect } from "react-router-dom";
import LoadingStatus from "src/components/common/LoadingStatus";
import "src/css/pages/projects/project/projectpage.css";
import { TIMEOUT } from "src/global";
import fs from "src/services/config/fbConfig";
import * as xmlJs from "xml-js";
import { IProjectProps, IProjectState, IStatementItem } from "./interfaces";
import { importAPSStatements } from "./statements/advanced/dualrate/APSStatementsImporter";
import { ICSR, importCSRXml } from "./statements/CulinSolarTrackerImporter";

export default class ProjectPage extends Component<IProjectProps, IProjectState> {
  private projectDocument: firebase.firestore.DocumentReference;
  private statementsCollection: firebase.firestore.CollectionReference;
  private unsubscribe: any;
  public constructor(props: IProjectProps) {
    super(props);

    this.state = {
      loading: true,
      statements: [],
      useSimplifiedStatement: false,
      rateType: 0,
      isDirty: false,
      checkEstimatedGeneration: false,
      allowStatementParsing: false,
      allowStatementUpload: false,
      priorDataEditable: false,
      location: "",
      showImport: false,
      file: null,
      importing: false,
      pdfFiles: null,
    };

    this.handleAccount = this.handleAccount.bind(this);
    this.handleSupplyCompany = this.handleSupplyCompany.bind(this);
    this.handleDeliveryCompany = this.handleDeliveryCompany.bind(this);
    this.handleGuaranteedPowerTable = this.handleGuaranteedPowerTable.bind(this);
    this.renderProjectNavbar = this.renderProjectNavbar.bind(this);
    this.updateStatements = this.updateStatements.bind(this);

    this.addStatement = this.addStatement.bind(this);
    this.deleteStatementWithConfirmation = this.deleteStatementWithConfirmation.bind(this);
    this.deleteStatement = this.deleteStatement.bind(this);
    this.editStatement = this.editStatement.bind(this);
    this.editProjectSettings = this.editProjectSettings.bind(this);
    this.viewAnnualSummaryByMonthReport = this.viewAnnualSummaryByMonthReport.bind(this);

    this.hideImport = this.hideImport.bind(this);
    this.renderImportCSRFile = this.renderImportCSRFile.bind(this);
    this.importClicked = this.importClicked.bind(this);
    this.handleFilenameChanged = this.handleFilenameChanged.bind(this);
    this.validateXmlFile = this.validateXmlFile.bind(this);
    this.importCSRFile = this.importCSRFile.bind(this);
    this.handleAPSFilenamesChanged = this.handleAPSFilenamesChanged.bind(this);
    this.importAPSStatements = this.importAPSStatements.bind(this);

    this.viewStatementsInTable = this.viewStatementsInTable.bind(this);
    this.viewExtendedAnnualSummaryByMonthReport = this.viewExtendedAnnualSummaryByMonthReport.bind(
      this
    );

    this.downloadFile = this.downloadFile.bind(this);
  }

  public componentWillMount() {
    this.projectDocument = fs.fs.collection("projects").doc(this.props.match.params.id);
    this.statementsCollection = this.projectDocument.collection("statements");
    this.unsubscribe = this.statementsCollection
      .orderBy("statementDate")
      .onSnapshot(this.updateStatements);
  }

  public componentDidMount() {
    this.projectDocument
      .get()
      .then(doc => {
        if (doc.exists) {
          const {
            useSimplifiedStatement,
            rateType,
            priorDataEditable,
            allowStatementParsing,
            allowStatementUpload,
          } = doc.data() as any;
          this.setState({
            useSimplifiedStatement:
              useSimplifiedStatement !== undefined ? useSimplifiedStatement : true,
            rateType: rateType ? rateType : 0,
            priorDataEditable: priorDataEditable !== undefined ? priorDataEditable : false,
            allowStatementParsing: allowStatementParsing ? allowStatementParsing : false,
            allowStatementUpload: allowStatementUpload ? allowStatementUpload : false,
          });
        }
      })
      .then(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, TIMEOUT);
      });
  }

  public componentWillUnmount() {
    this.unsubscribe(this.updateStatements);
  }

  public render() {
    const { appService } = this.props;

    if (!appService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }

    if (this.state.loading) {
      return <LoadingStatus text="Loading..." type="Rings" />;
    }

    if (this.state.importing) {
      return <LoadingStatus text="Importing..." type="Rings" />;
    }

    const cutoff = 767;
    const buttonCutoff = 768;
    const showFilename =
      window.screen.availWidth > cutoff &&
      (this.state.allowStatementParsing || this.state.allowStatementUpload);
    const includeServiceDates = window.screen.availWidth > cutoff;
    const showButtonText = window.screen.availWidth > buttonCutoff;
    const { statements } = this.state;
    return (
      <div className="container-fixed-navbar">
        {this.renderProjectNavbar()}
        {!this.state.useSimplifiedStatement ? (
          <h5 style={{ textAlign: "center" }}>
            For advanced statements, data is best entered in chronologic order. If you enter data in
            non-chronological order, re-edit each statement and save from start to finish to
            recalculate values.
          </h5>
        ) : null}
        <div className="container statements-list">
          <Table id="statements" striped={true} condensed={true}>
            <colgroup>
              {showButtonText ? <col width="115" /> : <col width="75" />}
              <col width="65" />
              {includeServiceDates ? <col width="65" /> : null}
              {includeServiceDates ? <col width="65" /> : null}
              <col width="50" />
              {showFilename ? <col width="250" /> : null}
            </colgroup>
            <thead>
              <tr>
                <th colSpan={6} style={{ textAlign: "center" }}>
                  <h3>{this.props.appService.getActiveProjectLocation()} Statements</h3>
                </th>
              </tr>
              <tr>
                <th id="statement_actions">Action</th>
                <th id="statement_date">Statement Date</th>
                {includeServiceDates ? <th id="statement_serviceStart">Service Start</th> : null}
                {includeServiceDates ? <th id="statement_serviceEnd">Service End</th> : null}
                <th id="statement_due">Total Due</th>
                {showFilename ? <th id="satement_file">PDF Statement</th> : null}
              </tr>
            </thead>
            <tbody>
              {statements &&
                statements.map((statement, index, statements) => (
                  <tr key={statement.id}>
                    <td id="statement_actions_cell">
                      <Button
                        bsStyle="primary"
                        bsSize="small"
                        className="button-right"
                        // tslint:disable-next-line:jsx-no-lambda
                        onClick={() => this.editStatement(statements, index)}
                      >
                        <Glyphicon glyph="glyphicon glyphicon-edit" />
                        {showButtonText ? " Edit" : ""}
                      </Button>
                      <Button
                        className="button-right"
                        bsStyle="danger"
                        bsSize="small" // tslint:disable-next-line:jsx-no-lambda
                        onClick={() => this.deleteStatementWithConfirmation(statement.id)}
                      >
                        <Glyphicon glyph="glyphicon glyphicon-remove-sign" />
                        {showButtonText ? " Delete" : ""}
                      </Button>
                    </td>
                    <td id="statement_date_cell">
                      {new Date(statement.statementDate).toISOString().substring(0, 10)}
                    </td>
                    {includeServiceDates ? (
                      <td id="statement_serviceStart_cell">
                        {new Date(statement.serviceStartDate).toISOString().substring(0, 10)}
                      </td>
                    ) : null}
                    {includeServiceDates ? (
                      <td id="statement_serviceEnd_cell">
                        {new Date(statement.serviceEndDate).toISOString().substring(0, 10)}
                      </td>
                    ) : null}
                    <td id="statement_due_cell">{statement.totalAmountDue.toFixed(2)}</td>
                    {showFilename ? (
                      <td id="statement_file_cell">
                        <a
                          href="#"
                          // tslint:disable-next-line:jsx-no-lambda
                          onClick={() =>
                            this.downloadFile(statement.storagePath, statement.filename)
                          }
                        >
                          {" "}
                          {statement.filename}
                        </a>
                      </td>
                    ) : null}
                    {/* <td id="statement_id_cell">{statement.id}</td> */}
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }

  private downloadFile(storagePath: string, filename: string) {
    if (storagePath !== "" && filename !== "") {
      fs.fsStorage
        .ref()
        .child(storagePath)
        .getDownloadURL()
        .then(url => {
          const xhr = new XMLHttpRequest();
          xhr.responseType = "arraybuffer";
          xhr.onloadend = event => {
            const downloadedFileBlob = new Blob([xhr.response], { type: "application/pdf" });
            const data = window.URL.createObjectURL(downloadedFileBlob);
            const link = document.createElement("a");
            link.href = data;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(data);
            }, TIMEOUT);
          };
          xhr.open("GET", url);
          xhr.send();
        });
    }
  }

  private renderProjectNavbar() {
    return (
      <div className="subnavbar-navbar-container">
        <Navbar inverse={false} collapseOnSelect={true}>
          <Navbar.Header style={{ marginLeft: "3px" }}>
            <Navbar.Brand>
              <NavLink to="/projects">
                <Glyphicon glyph="glyphicon glyphicon-circle-arrow-left" className="button-right" />
                Back to Projects
              </NavLink>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight={true}>
              <NavItem>
                <Button
                  className="button-right button-top button-bottom"
                  bsStyle="primary"
                  bsSize="small"
                  onClick={this.addStatement}
                >
                  Add Statement
                </Button>
                {/* Only show the Import button for advanced single-rate projects */}
                {!this.state.useSimplifiedStatement ? (
                  <Button
                    className="button-right button-top button-bottom"
                    bsStyle="warning"
                    bsSize="small"
                    onClick={this.importClicked}
                  >
                    Import
                  </Button>
                ) : null}
                <DropdownButton
                  title="Accounts"
                  id="accounts"
                  bsSize="small"
                  className="button-right button-top button-bottom"
                >
                  <MenuItem onClick={this.handleAccount}>Accounts</MenuItem>
                  <MenuItem divider={true} />
                  <MenuItem onClick={this.handleSupplyCompany}>Supply Company</MenuItem>
                  <MenuItem onClick={this.handleDeliveryCompany}>Delivery Company</MenuItem>
                  <MenuItem divider={true} />
                  <MenuItem onClick={this.handleGuaranteedPowerTable}>
                    Guranteed Power Table
                  </MenuItem>
                </DropdownButton>
                <Button
                  className="button-right button-top button-bottom"
                  bsSize="small"
                  onClick={this.editProjectSettings}
                >
                  <Glyphicon glyph="glyphicon glyphicon-cog" /> Options
                </Button>
                <Button
                  className="button-top button-bottom button-right"
                  bsSize="small"
                  onClick={this.viewStatementsInTable}
                >
                  <Glyphicon glyph="glyphicon glyphicon-th" /> Table
                </Button>
                <DropdownButton
                  title="Reports"
                  id="reports"
                  bsSize="small"
                  className="button-top button-bottom"
                  pullRight={false}
                >
                  <MenuItem onClick={this.viewAnnualSummaryByMonthReport}>Standard Report</MenuItem>
                  {this.state.rateType === 1 ? (
                    <MenuItem onClick={this.viewExtendedAnnualSummaryByMonthReport}>
                      Extended Report
                    </MenuItem>
                  ) : null}
                </DropdownButton>
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        {this.renderImportCSRFile()}
      </div>
    );
  }

  private viewStatementsInTable(e: any) {
    e.preventDefault();
    if (this.state.rateType === 1) {
      this.props.history.push("/advancedDualRateTablePage");
    } else {
      this.props.history.push("/advancedSingleRateTablePage");
    }
  }

  private renderImportCSRFile() {
    const labelWidth: number = 5;
    const inputWidth: number = 7;
    return (
      <Modal show={this.state.showImport} onHide={this.hideImport} backdrop="static">
        <Modal.Header closeButton={true}>
          <Modal.Title>Import Culin SolarTracker Data</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ paddingBottom: "0px", marginBottom: "0px" }}>
          <Form inline={true}>
            {this.state.rateType === 0 ? (
              <FormGroup controlId="csrFile">
                <Col
                  style={{ marginTop: "0px" }}
                  xs={labelWidth}
                  sm={labelWidth}
                  md={labelWidth}
                  componentClass={ControlLabel}
                >
                  Culin SolarTracker Data File
                </Col>
                <Col xs={inputWidth} sm={inputWidth} md={inputWidth}>
                  <FormControl
                    type="file"
                    onChange={this.handleFilenameChanged}
                    accept="application/xml"
                  />
                </Col>
              </FormGroup>
            ) : (
              <FormGroup controlId="pdfStatements">
                <Col
                  style={{ marginTop: "0px" }}
                  xs={labelWidth}
                  sm={labelWidth}
                  md={labelWidth}
                  componentClass={ControlLabel}
                >
                  APS Statements
                </Col>
                <Col xs={inputWidth} sm={inputWidth} md={inputWidth}>
                  <FormControl
                    type="file"
                    onChange={this.handleAPSFilenamesChanged}
                    accept="application/pdf"
                    multiple={true}
                  />
                </Col>
              </FormGroup>
            )}
          </Form>
          {this.state.rateType === 0 ? (
            <p
              style={{
                margin: "0px",
                marginTop: "12px",
                verticalAlign: "bottom",
              }}
            >
              By clicking on the Import button, statement data in the provided CSR file will be read
              and imported. This cannot be undoned.
            </p>
          ) : (
            <p
              style={{
                margin: "0px",
                marginTop: "12px",
                verticalAlign: "bottom",
              }}
            >
              By clicking on the Import button, the data from the selected PDF statements will be
              imported. Each PDF file represents its own statement. Once the statements are
              imported, you should review the data for accuracy.
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="warning"
            bsSize="small"
            onClick={this.state.rateType === 0 ? this.importCSRFile : this.importAPSStatements}
          >
            Import
          </Button>
          <Button bsStyle="danger" bsSize="small" className="button-left" onClick={this.hideImport}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  private handleFilenameChanged(e: any) {
    const xmlFile: File = e.target.files[0];
    if (xmlFile) {
      if (this.validateXmlFile(xmlFile)) {
        this.setState({ file: xmlFile });
      }
    }
  }

  private handleAPSFilenamesChanged(e: any) {
    const pdfFiles: FileList = e.target.files;
    this.setState({ pdfFiles });
  }

  private importAPSStatements(e: any) {
    e.preventDefault();
    let hasOneOrMoreInvalidFiles: boolean = false;
    const { pdfFiles } = this.state;
    if (pdfFiles) {
      for (let i = 0; i < pdfFiles.length; i++) {
        const pdfFile = pdfFiles.item(i);
        if (pdfFile) {
          if (pdfFile.type !== "application/pdf") {
            hasOneOrMoreInvalidFiles = true;
          }
        }
      }
      if (hasOneOrMoreInvalidFiles) {
        alert(
          "You selected one or more invalid PDF files.  Make sure all selected files are PDF files."
        );
      } else {
        const { appService } = this.props;
        const projectId = appService.getActiveProjectId();
        this.setState({ importing: true, showImport: false });
        importAPSStatements(
          projectId,
          this.projectDocument,
          this.statementsCollection,
          pdfFiles
        ).then(() => {
          this.setState({ importing: false });
        });
      }
    }
  }

  private importCSRFile(e: any) {
    e.preventDefault();
    if (!this.state.file) {
      alert("There is no valid file selected.");
    } else {
      if (this.state.statements.length === 0) {
        this.setState({ showImport: false, importing: true });
        const fileReader: FileReader = new FileReader();
        fileReader.onload = () => {
          const buffer = fileReader.result;
          if (buffer) {
            const xmlBuffer = buffer as string;
            const xml = xmlJs.xml2json(xmlBuffer, { compact: true, spaces: 2 });
            const csr = JSON.parse(xml) as ICSR;

            importCSRXml(this.projectDocument, this.statementsCollection, csr).then((csr: ICSR) => {
              setTimeout(() => {
                this.setState({ importing: false });
              }, TIMEOUT);
            });
          }
        };
        fileReader.onerror = error => {
          console.log(error);
          this.setState({ importing: false });
        };
        fileReader.readAsText(this.state.file);
      } else {
        alert(
          "You must delete your statements before importing from a Culin SolarTracker data file."
        );
      }
    }
  }

  private validateXmlFile(xmlFile: File): boolean {
    return xmlFile.type === "text/xml" || xmlFile.name.endsWith("csr");
  }

  private importClicked(e: any) {
    e.preventDefault();
    this.setState({ showImport: true });
  }

  private hideImport() {
    this.setState({ showImport: false });
  }

  private handleAccount() {
    this.props.history.push(`/account/${this.props.appService.getActiveProjectId()}`);
  }
  private handleSupplyCompany() {
    this.props.history.push(`/supplycompany/${this.props.appService.getActiveProjectId()}`);
  }
  private handleDeliveryCompany() {
    this.props.history.push(`/deliverycompany/${this.props.appService.getActiveProjectId()}`);
  }
  private handleGuaranteedPowerTable() {
    this.props.history.push(`/guaranteedpowertable/${this.props.match.params.id}`);
  }
  private updateStatements(querySnapshot: firebase.firestore.QuerySnapshot) {
    const statements: IStatementItem[] = [];

    querySnapshot.forEach(doc => {
      const {
        yearsWithSolar,
        statementDate,
        serviceStartDate,
        serviceEndDate,
        creditBalance,
        totalAmountDue,
        storagePath,
        filename,
      } = doc.data();

      statements.push({
        id: doc.id,
        yearsWithSolar,
        statementDate,
        serviceStartDate: serviceStartDate ? serviceStartDate : Date.now(),
        serviceEndDate: serviceEndDate ? serviceEndDate : Date.now(),
        creditBalance,
        totalAmountDue,
        storagePath,
        filename,
      });
    });

    console.log("# of statements", statements.length);
    this.setState({ statements, loading: false });
  }

  private addStatement() {
    this.statementsCollection.add({
      yearsWithSolar: 0,
      statementDate: Date.now(),
      creditBalance: 0,
      totalAmountDue: 0,
    });
  }
  private deleteStatementWithConfirmation(id: string) {
    if (confirm("Are you sure you want to delete this statement?")) {
      this.deleteStatement(id);
    }
  }
  private deleteStatement(id: string) {
    this.projectDocument
      .collection("simpleDualRateStatements")
      .doc(id)
      .delete();
    this.projectDocument
      .collection("simpleSingleRateStatements")
      .doc(id)
      .delete();
    let serviceCharges = this.projectDocument
      .collection("advancedSingleRateStatements")
      .doc(id)
      .collection("serviceCharges");
    serviceCharges
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          serviceCharges.doc(doc.id).delete();
        });
      })
      .then(() => {
        this.projectDocument
          .collection("advancedSingleRateStatements")
          .doc(id)
          .delete();
      });
    serviceCharges = this.projectDocument
      .collection("advancedDualRateStatements")
      .doc(id)
      .collection("serviceCharges");
    const taxesAndFees = this.projectDocument
      .collection("advancedDualRateStatements")
      .doc(id)
      .collection("taxesAndFees");
    serviceCharges
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            serviceCharges.doc(doc.id).delete();
          }
        });
      })
      .then(() => {
        taxesAndFees.get().then(querySnapshot => {
          querySnapshot.forEach(doc => {
            if (doc.exists) {
              taxesAndFees.doc(doc.id).delete();
            }
          });
        });
      })
      .then(() => {
        this.projectDocument
          .collection("advancedDualRateStatements")
          .doc(id)
          .delete();
      });
    this.statementsCollection
      .doc(id)
      .get()
      .then(doc => {
        if (doc.exists) {
          const { storagePath } = doc.data() as any;
          if (storagePath && storagePath !== "") {
            fs.fsStorage
              .ref()
              .child(storagePath)
              .delete();
          }
        }
      });
    this.statementsCollection.doc(id).delete();
  }

  private editStatement(statements: IStatementItem[], index: number) {
    const statement: IStatementItem = statements[index];
    const id = statement.id;
    let priorId = null;
    if (index > 0) {
      const priorStatement: IStatementItem = statements[index - 1];
      priorId = priorStatement.id;
      if (this.state.priorDataEditable) {
        priorId = null;
      }
    }
    if (this.state.useSimplifiedStatement) {
      if (this.state.rateType === 0) {
        /* Single Rate*/
        this.props.history.push(`/simplesingleratestatement/${id}`);
      } else {
        /* Dual Rate*/
        this.props.history.push(`/simpledualratestatement/${id}`);
      }
    } else {
      if (this.state.rateType === 0) {
        /* Single Rate*/
        if (priorId) {
          this.props.history.push(`/advancedsingleratestatement/${id}/${priorId}`);
        } else {
          this.props.history.push(`/advancedsingleratestatement/${id}`);
        }
      } else {
        /* Dual Rate*/
        if (priorId) {
          this.props.history.push(`/advanceddualratestatement/${id}/${priorId}`);
        } else {
          this.props.history.push(`/advanceddualratestatement/${id}`);
        }
      }
    }
  }

  private editProjectSettings(e: any): void {
    e.preventDefault();
    const { appService } = this.props;
    const projectId = appService.getActiveProjectId();
    this.props.history.push(`/projectsettings/${projectId}`);
  }
  private viewAnnualSummaryByMonthReport(): void {
    this.props.history.push(`/annualsummarybymonthreport`);
  }
  private viewExtendedAnnualSummaryByMonthReport(): void {
    this.props.history.push(`/extendedannualsummarybymonthreport`);
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/ProjectPage.tsx